import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserComponent } from '../components/user/user.component';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { RouterModule, Routes, Router } from '@angular/router';
//import { AppRoutingModule } from '../modules/app-routing.module';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthService {
  isAuthenticated: boolean;
  errorMessage: any;
  access_token: any;

  constructor(private _http : Http, private router: Router, private oauthService: OAuthService) { 

  }

  public login(userName: string, password: string) {
    // this.GetAccessToken(userName, password)
    //   .subscribe(u => {
    //       this.onSubscribe(u)
    //   }, error => {
    //     this.errorMessage = "An error occured." //<any>error;
    //     console.log(error);
    //   });

    this.oauthService.fetchTokenUsingPasswordFlow(userName, password).then((resp) => {
          console.log("logging in...");
          console.log(resp);  
          this.router.navigate(['/dashboard']);
        }, () => { console.log("error logging in..."); }).then(() => {

          // Using the loaded user data
          let claims = this.oauthService.getIdentityClaims();          
          //if (claims) console.debug('given_name', claims.given_name);
          console.log("claims...");
          console.log(claims);  

        }, () => { console.log("error getting claims..."); });

        
  }

  RefreshToken(){
    this.oauthService.refreshToken().then(() => {
      console.debug('token refreshed...');
    }, () => { console.log("error refreshing token"); });
  }

  GetAccessToken(userName: string, password: string): Observable<UserComponent> {  
    
  let body = new URLSearchParams();
  body.set('user', userName);
  body.set('password', password);
  body.set('grant_type', "password");

  var creds = "username=" + userName + "&password=" + password + "&grant_type=password";

  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  
  
    return this._http.post('/token', creds, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  onSubscribe(token: any) {
    console.log(token);

    if (token == "invalid_grant") {  
      this.isAuthenticated = false;  
      this.errorMessage = "Invalid user name or password."
      console.log('invalid grant');  
    }  
    else {  
      this.access_token = token;
        this.isAuthenticated = true;   
        this.errorMessage = "";       
        sessionStorage.setItem('accessToken', token);
        console.log('got access token');
        console.log(token);
        this.router.navigate(['/licenses']);
    } 
    
}

getAccessToken() : string
{
  return sessionStorage.getItem('accessToken');
}

isLoggedIn(): boolean
{
  let token = this.oauthService.hasValidAccessToken();
  if(token)
    return true;
  else
    return false;
}

  private extractData(res: Response) {
    let data
    if (res.text()) {
      data = res.json();
    }
    return data || {};
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts